import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Breadcrumb } from './breadcrumb/breadcrumb';

@Component({
  selector: 'srp-sub-header',
  imports: [Breadcrumb],
  templateUrl: './sub-header.html',
  styleUrl: './sub-header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SubHeader {
  constructor() { }
}
